<template>
  <v-content>
    <OLoadingDialog :value="isLoading" />

    <div v-if="isLoading && results == null" class="jumbo">
      <v-icon>mdi-refresh</v-icon>
      Carregando...
    </div>

    <div v-if="!isLoading && results == null" class="jumbo">
      <v-icon>mdi-folder-upload-outline</v-icon>
      Faça upload de um arquivo de comparação para prosseguir.
      <div style="max-width: 200px" class="mt-4">
        <v-btn @click="upload">Carregar JSON...</v-btn>
      </div>
    </div>

    <div v-if="results != null">
      <v-toolbar dark color="grey darken-2">
        <v-toolbar-title class="ml-4">
          Comparação ─ {{ results.orgCode }} ─ {{ results.comparedAt | moment }}
        </v-toolbar-title>

        <v-spacer />

        <v-flex xs8 class="flex-grow-0">
          <v-tabs
            v-model="currentTab"
            right
            dark
            background-color="transparent"
          >
            <v-tab
              v-for="t in tabItems"
              :key="t.value"
              :href="t.value"
              v-html="t.label"
            />
          </v-tabs>
        </v-flex>
      </v-toolbar>

      <div class="maxh-2bar h-row-stretch">
        <!-- <div class="oderon-col-3 pa-2">
          <Sidebar :customer="row" @reload="reload" />
        </div> -->
        <!-- <div class="oderon-col-12"> -->
        <v-tabs-items v-model="currentTab" style="width: 100%">
          <v-tab-item value="drivers">
            <Drivers
              :value="results.drivers"
              :allClientIds="allClientIds"
            />
          </v-tab-item>
          <v-tab-item value="eis">
            <EIs :value="results.eis" :allVehicles="results.allAfterVehicles" />
          </v-tab-item>
          <v-tab-item value="polygons">
            <Polygons
              :value="results.polygons"
              :allVehicles="results.allAfterVehicles"
            />
          </v-tab-item>
        </v-tabs-items>
        <!-- </div> -->
      </div>
    </div>
  </v-content>
</template>

<script>
import { openFile } from 'oderon-vue/utils'

export default {
  components: {
    Drivers: require('./Drivers.vue').default,
    EIs: require('./EIs.vue').default,
    Polygons: require('./Polygons.vue').default
  },
  data() {
    return {
      isLoading: false,
      results: null,
      allClientIds: null,
      currentTab: null, // getPrefTab(),
      barColor: 'blue-grey darken-1',
      tabItems: [
        { label: 'Drivers', value: '#drivers' },
        { label: 'EIs', value: '#eis' },
        { label: 'Polygons', value: '#polygons' }
      ]
    }
  },

  methods: {
    async upload() {
      this.$loading(async () => {
        let str = await openFile({ accepts: 'application/json' })
        this.results = JSON.parse(str)

        const allClientIds = new Set()

        for (let x of this.results.drivers.before)
          if ( x.vehicle ) allClientIds.add(x.vehicle.clientId)
        for (let x of this.results.drivers.after)
          if ( x.vehicle ) allClientIds.add(x.vehicle.clientId)
        for (let x of this.results.polygons.before)
          allClientIds.add(x.clientId)
        for (let x of this.results.polygons.after) allClientIds.add(x.clientId)
        for (let x of this.results.eis.before) allClientIds.add(x.clientId)
        for (let x of this.results.eis.after) allClientIds.add(x.clientId)

        this.allClientIds = Array.from(allClientIds).filter(x => x != null)
      })
    }
  }
}
</script>

<style></style>
